import {patchState, signalStore, withMethods, withState} from '@ngrx/signals';
import {DataStorageService} from 'src/app/infrastructure/data-storage.service';
import {inject} from '@angular/core';

export enum LocationAgeFilterPeriod {
  ALL = 'Show all locations',
  LAST_24_HOURS = 'Hide locations older than 24 hours',
  LAST_3_DAYS = 'Hide locations older than 3 days',
  LAST_7_DAYS = 'Hide locations older than 7 days',
  LAST_30_DAYS = 'Hide locations older than 30 days',
  LAST_60_DAYS = 'Hide locations older than 60 days',
}

const initialState = {
  initializedMap: false,
  locationAgeFilterPeriod: LocationAgeFilterPeriod.ALL,
  waterPointLayer: true,
  precipitationSamplePointLayer: true,
  animalLocationLayer: true,
  historicAnimalLocationLayer: false,
  gatewayLayer: true,
  proximitySamplePointLayer: true,
  grazingPatternLayer: false,
  signalStrengthAnalysisLayer: false,
  paddockLayer: true
};

export const MapStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, dataStorageService = inject(DataStorageService)) => ({
    async init(): Promise<void> {
      const period = await dataStorageService.getLocationAgeFilterPeriod();
      patchState(store, { locationAgeFilterPeriod: period });
    },
    async setLocationAgeFilterPeriod(period: LocationAgeFilterPeriod): Promise<void> {
      await dataStorageService.setLocationAgeFilterPeriod(period);
      patchState(store, { locationAgeFilterPeriod: period });
    },
    showWaterPointLayer() {
      patchState(store, {waterPointLayer: true});
    },
    hideWaterPointLayer() {
      patchState(store, {waterPointLayer: false});
    },
    showPrecipitationSamplePointLayer() {
      patchState(store, {precipitationSamplePointLayer: true});
    },
    hidePrecipitationSamplePointLayer() {
      patchState(store, {precipitationSamplePointLayer: false});
    },
    showAnimalLocationLayer() {
      patchState(store, {animalLocationLayer: true});
    },
    hideAnimalLocationLayer() {
      patchState(store, {animalLocationLayer: false});
    },
    showHistoricAnimalLocationLayer() {
      patchState(store, {historicAnimalLocationLayer: true});
    },
    hideHistoricAnimalLocationLayer() {
      patchState(store, {historicAnimalLocationLayer: false});
    },
    showGatewayLayer() {
      patchState(store, {gatewayLayer: true});
    },
    hideGatewayLayer() {
      patchState(store, {gatewayLayer: false});
    },
    showProximitySamplePointLayer() {
      patchState(store, {proximitySamplePointLayer: true});
    },
    hideProximitySamplePointLayer() {
      patchState(store, {proximitySamplePointLayer: false});
    },
    showGrazingPatternLayer() {
      patchState(store, {grazingPatternLayer: true});
    },
    hideGrazingPatternLayer() {
      patchState(store, {grazingPatternLayer: false});
    },
    showSignalStrengthAnalysisLayer() {
      patchState(store, {signalStrengthAnalysisLayer: true});
    },
    hideSignalStrengthAnalysisLayer() {
      patchState(store, {signalStrengthAnalysisLayer: false});
    },
    showPaddockLayer() {
      patchState(store, {paddockLayer: true});
    },
    hidePaddockLayer() {
      patchState(store, {paddockLayer: false});
    },
    resetLayers() {
      patchState(store, {
        waterPointLayer: true,
        precipitationSamplePointLayer: true,
        animalLocationLayer: true,
        historicAnimalLocationLayer: false,
        gatewayLayer: true,
        proximitySamplePointLayer: true,
        grazingPatternLayer: false,
        signalStrengthAnalysisLayer: false,
        paddockLayer: true
      });
    },
    setInitializedMap(initialized: boolean) {
      patchState(store, { initializedMap: initialized });
    }
  })
));
